<template>
    <div  v-loading.fullscreen.lock="uploading"
    element-loading-text="数据上传中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-form :inline="true" :model="searchForm">
            <el-form-item>
                <el-button type="primary" @click="showEndtimeChg">批量更改</el-button>
                <el-button type="primary" @click="showEndtimeQuery">批量查询</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border  height="611" highlight-current-row>
            <el-table-column prop="createTime" label="导入时间 "></el-table-column>
            <el-table-column prop="totalNum" label="导入总数"></el-table-column>
            <el-table-column prop="successNum" label="导入成功数"></el-table-column>         
            <el-table-column prop="failNum" label="导入失败数"></el-table-column>
            <el-table-column prop="disposeName" label="导入人"></el-table-column>
            <el-table-column prop="simLife" label="续费时长"></el-table-column>
            <el-table-column label="操作" width="140px">
                <template slot-scope="scope">
                    <el-button type="text" @click="endtimeChgRecordListHandle(scope.row.id, $event)">查看失败</el-button>                   
                </template>    
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>
        <el-dialog title="批量更改" :visible.sync="endtimeVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form :model="endtimeForm" label-width="120px">
                <el-form-item label="导入Excel：">
                    <el-upload ref="upload" :action="uploadUrl('sim/update/expire/time')" :headers="setHeader()" :limit="1" :auto-upload="false" :data="endtimeForm" :file-list="endtimeForm.fileList" :on-success = "handleSuccess">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportExcel('/excel/update/sim/template')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
<!--                 <el-form-item label="续费时长：">
                    <el-row>
                        <el-col :span="22">
                            <el-input v-model="endtimeForm.simLife"></el-input>
                        </el-col>
                        <el-col :span="2" class="center">月</el-col>
                    </el-row>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureEndtimeChg">确 定</el-button>
            </div> 
        </el-dialog>
        <!-- 批量查询    -->
        <el-dialog title="批量查询" :visible.sync="endtimeQueryVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form :model="endtimeForm" label-width="120px">
                <el-form-item label="导入Excel：">
                    <el-upload ref="upload" :action="uploadUrl('sim/batch/import/expire')" :headers="setHeader()" :limit="1" :auto-upload="false" :data="endtimeForm" :file-list="endtimeForm.fileList" :on-success = "handleSuccess2">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportExcel('/excel/query/update/sim/template')">导出模板</el-button>
                    </el-upload>
                </el-form-item>
<!--                 <el-form-item label="续费时长：">
                    <el-row>
                        <el-col :span="22">
                            <el-input v-model="endtimeForm.simLife"></el-input>
                        </el-col>
                        <el-col :span="2" class="center">月</el-col>
                    </el-row>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureEndtimeQuery">确 定</el-button>
            </div> 
        </el-dialog>

        <el-dialog title="充值失败列表" :visible.sync="endtimeFailVisible" width="1000px" :close-on-click-modal="false">
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="iccid" label="ICCID号" width="200px"></el-table-column>
                <el-table-column prop="intoNo" label="接入号" width="200px"></el-table-column>
                <el-table-column prop="remark" label="错误描述"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>            
    </div>
</template>
<script>
import {endtimeChgList, endtimeChg, endtimeChgRecordList, getImportData, getImportDataQuery} from '@/api/endtime.js'
import common from '@/utils/common.js'

export default {
    data(){         
        return {
            searchForm: {
                
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            endtimeVisible: false,
            endtimeQueryVisible: false,
            endtimeForm: {
                fileList: [],
                simLife: null,
                time: '',
            },
            endtimeFailVisible: false,
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0                
            },   
            currentId_fail: '',

            uploading:false,
            importdata:'',  // 导入接口成功返回的data
        }
    },
    methods: {
        cancel(){
            this.uploading = false;
            this.endtimeForm.fileList = [];
            this.$refs.upload.clearFiles();
            this.endtimeVisible = false;
            this.endtimeQueryVisible = false;
        },
        endtimeChgListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);            
            endtimeChgList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        showEndtimeChg(){
            this.endtimeVisible = true;
        },
        showEndtimeQuery() {
            this.endtimeQueryVisible = true;
        },       
        sureEndtimeChg(){
            this.$refs.upload.submit();   //号段批量导入
            this.uploading = true;
        },
        sureEndtimeQuery() {
            // this.$refs.upload.submit();   //号段批量导入
            this.$refs.upload.submit();
            this.uploading = true;
        },  
        handleChange(file, fileList){
            if(fileList.length > 1){
                this.$refs.upload.fields[0].clearValidate();
            }
        },      
        handleSuccess(res){
            if(res.code == 200){
                this.endtimeVisible = false;
                this.endtimeChgListHandle();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
            this.cancel();
        }, 
        handleSuccess2(res){
            if(res.code == 200){
                this.endtimeQueryVisible = false;
                window.location.href = '/web/api/v1/xxtx/download/batch/query/expire?'+'time='+res.data
                this.endtimeChgListHandle();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
            this.cancel();
        },
        endtimeChgRecordListHandle(id, $event){
            this.endtimeFailVisible = true;
            this.currentId_fail = id;
            var searchForm = {
                id: this.currentId_fail,
                state: 2
            }            
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', searchForm);            
            endtimeChgRecordList(data).then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },      
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.endtimeChgListHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.endtimeChgListHandle();
        },
        importData() {
            getImportData({}).then(res => {
                if(res.data.code == 200) {
                    this.importdata = res.data.data
                }
                else {
                    this.$message.error(res.data.message);
                }
            })
        }         
    },
    created(){
        this.endtimeChgListHandle();
    }
}
</script> 